module.exports = __webpack_public_path__ + "static/img/office.ac7d282.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lp/office.png
// module id = 9RNj
// module chunks = 3